import { createSelector } from '@ngrx/store';
import {
  ListItemState,
  orderGuideItemAdapter,
  orderGuideItemsLoaded,
  selectOrderGuideItemState,
} from '@usf/ngrx-list';

export const customerProductNumberSelector = customerProductNumber =>
  createSelector(
    orderGuideItemAdapter.getSelectors(selectOrderGuideItemState).selectAll,
    orderGuideItemsLoaded(),

    (orderGuideItems, ogLoaded) => {
      if (ogLoaded) {
        let custProdMatch = orderGuideItems.filter(
          ogItem =>
            ogItem?.customerProductNumber.toLowerCase() ===
            customerProductNumber.toLowerCase(),
        );
        const custProdMap: Map<string, ListItemState> = new Map();
        custProdMatch.forEach(custProd => {
          custProdMap.set(custProd.customerProductNumber, custProd);
        });
        return custProdMap;
      }
    },
  );
